import ppiConfig from './brand_configs/ppi.json';
import assanteConfig from './brand_configs/assante.json';
import wb4aConfig from './brand_configs/wb4a.json';

const brandConfigs = {
  ppi: ppiConfig,
  assante: assanteConfig,
  wb4a: wb4aConfig,
};

const requiredFields = [
  'fullNameEn',
  'fullNameFr',
  'shortName',
  'supportLinks',
  'paymentInformationLink',
  'signupLink',
  'advisorServiceAgreementLink',
  'advisorResources',
  'advisorServiceAgreementUrl',
  'advisorToolsUrl',
  'marketingResourceCentreUrl',
  'inviteMessageEn',
  'inviteMessageFr',
  'auth',
  'brochureSite',
  'allowSignup',
  'externalProfile',
];

const allowedFields = [
  'allowWorksFor',
  'accessUnavailableContactTitle',
  'accessUnavailableContactEmail',
];

export function validateConfigs(requiredFields, allowedFields, configs) {
  for (const brand in configs) {
    const config = configs[brand];
    const configKeys = Object.keys(config);
    const validConfig = configKeys.every(key => requiredFields.includes(key) || allowedFields.includes(key))
      && requiredFields.every(key => configKeys.includes(key));
    if (!validConfig) {
      throw new Error({ message: 'Invalid configuration, missing required field or extra field that is not allowed', config });
    }
  }
}

validateConfigs(requiredFields, allowedFields, brandConfigs);

export default function getBrandConfig(brand = null, locale = 'en') {
  const brandIdentifier = brand || (process && process.env && process.env.WHITELABEL_BRAND ? process.env.WHITELABEL_BRAND : 'wb4a');
  const config = brandConfigs[brandIdentifier];
  config.brand = brandIdentifier;
  config.fullName = (locale === 'fr-CA' ? config.fullNameFr : config.fullNameEn);
  config.inviteMessage = (locale === 'fr-CA' ? config.inviteMessageFr : config.inviteMessageEn);

  return config;
}
